import { type AnalyticsKpiLineChartProps, KpiLineChart } from '../../Charts';

export type StatsCardGraphProps = AnalyticsKpiLineChartProps;

export const StatsCardGraph = (props: StatsCardGraphProps) => (
  <div className="[&>div]:rounded-b-none">
    <KpiLineChart {...props} />
  </div>
);
